﻿export default class CookieManager {
    constructor() {
        this.dom = {
            $: window.$,
            jQuery: window.$,
            $window: $(window),
            $GDPRConsentExpiration: $("#GDPRConsentExpiration"),
            $acceptCookie: $("#accept-cookie"),
            $closeButton: $("#cookie-close"),
            $container: $('.cookie-section')
        };

        this.init();
    }

    init() {
        this.registerCookieBarEvents();
        this.hideEvent();
    }

    acceptCookie() {
        var expiration_date = new Date(this.dom.$GDPRConsentExpiration.val());
        if (expiration_date) {
            var cookie_string = '';
            var secure = window.location.protocol == "https:" ? "secure;" : "";
            cookie_string = "CookieConsent=true; path=/;domain=" + window.location.hostname.replace("www","") + "; " + secure + "expires=" + expiration_date.toUTCString();
            document.cookie = cookie_string;
            return true;
        }
    }

    registerCookieBarEvents() {
        this.dom.$acceptCookie.on("click", () => {
            if (this.acceptCookie()) {
                window.location.reload();
            }
        });
    }

    hideEvent() {
        this.dom.$closeButton.on("click", () => {
            this.dom.$container.hide();
        });
    }
}

